var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLinkedin = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 27,
  height: 27,
  viewBox: "0 0 27 27",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.5 7C20.0312 7 20.5 7.46875 20.5 8.03125V20C20.5 20.5625 20.0312 21 19.5 21H7.46875C6.9375 21 6.5 20.5625 6.5 20V8.03125C6.5 7.46875 6.9375 7 7.46875 7H19.5ZM10.7188 19V12.3438H8.65625V19H10.7188ZM9.6875 11.4062C10.3438 11.4062 10.875 10.875 10.875 10.2188C10.875 9.5625 10.3438 9 9.6875 9C9 9 8.46875 9.5625 8.46875 10.2188C8.46875 10.875 9 11.4062 9.6875 11.4062ZM18.5 19V15.3438C18.5 13.5625 18.0938 12.1562 16 12.1562C15 12.1562 14.3125 12.7188 14.0312 13.25H14V12.3438H12.0312V19H14.0938V15.7188C14.0938 14.8438 14.25 14 15.3438 14C16.4062 14 16.4062 15 16.4062 15.75V19H18.5Z",
  fill: "white"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 13.5,
  cy: 13.5,
  r: 13,
  stroke: "white"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLinkedin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/linkedin.7760f6e2.svg";
export { ForwardRef as ReactComponent };